import { motion } from "framer-motion";
import UrgenceButton from "@/components/site/UrgenceButton";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1a1918] text-[#f7f5f0] pt-20 md:pt-28 pb-8 relative overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="grid grid-cols-12 gap-6 md:gap-10 border-b border-[#f7f5f0]/20 pb-16"
        >
          <div className="col-span-12 md:col-span-7">
            <h3 className="font-serif-ed text-5xl md:text-7xl lg:text-[7rem] leading-[0.9] tracking-tighter">
              ProSecours
              <br />
              <span className="italic text-[#efece5]/85">
                Le réflexe des dirigeants.
              </span>
            </h3>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 flex flex-col justify-end gap-6">
            <div>
              <div className="overline text-[#f7f5f0]/50">Contact</div>
              <div className="mt-2 font-serif-ed text-2xl">
                <a href="tel:+33744883381" data-testid="footer-phone-link" className="hover:text-[#efece5]/80 transition-colors">
                  07 44 88 33 81
                </a>
              </div>
              <a
                href="mailto:contact@prosecours.fr"
                data-testid="footer-email-link"
                className="mt-2 inline-block text-sm text-[#f7f5f0]/70 transition-colors hover:text-[#f7f5f0]"
              >
                contact@prosecours.fr
              </a>
            </div>
            <div>
              <div className="overline text-[#f7f5f0]/50">
                Procédures & services
              </div>
              <div className="mt-3 flex flex-col gap-2 text-sm">
                <a href="/liquidation-judiciaire-paris" data-testid="footer-link-liquidation" className="text-[#f7f5f0]/70 hover:text-[#f7f5f0] transition-colors">Liquidation judiciaire Paris</a>
                <a href="/depot-de-bilan" data-testid="footer-link-depot" className="text-[#f7f5f0]/70 hover:text-[#f7f5f0] transition-colors">Dépôt de bilan</a>
                <a href="/redressement-judiciaire" data-testid="footer-link-redressement" className="text-[#f7f5f0]/70 hover:text-[#f7f5f0] transition-colors">Redressement judiciaire</a>
                <a href="/conciliation-entreprise" data-testid="footer-link-conciliation" className="text-[#f7f5f0]/70 hover:text-[#f7f5f0] transition-colors">Conciliation</a>
                <a href="/mandat-ad-hoc" data-testid="footer-link-mandat" className="text-[#f7f5f0]/70 hover:text-[#f7f5f0] transition-colors">Mandat ad hoc</a>
                <a href="/creation-de-societe" data-testid="footer-link-creation" className="text-[#f7f5f0]/70 hover:text-[#f7f5f0] transition-colors">Création de société</a>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="pt-8 grid grid-cols-12 gap-4 text-xs text-[#f7f5f0]/50">
          <div className="col-span-12 md:col-span-6 overline">
            © ProSecours — Tous droits réservés
          </div>
          <div className="col-span-12 md:col-span-6 md:text-right flex flex-wrap md:justify-end gap-4">
            <a href="/methode" data-testid="footer-methode" className="hover:text-[#f7f5f0] transition-colors">Fonctionnement</a>
            <a href="/journal" data-testid="footer-journal" className="hover:text-[#f7f5f0] transition-colors">Journal</a>
            <a href="/mentions-legales" data-testid="footer-mentions" className="hover:text-[#f7f5f0] transition-colors">Mentions légales</a>
            <a href="/confidentialite" data-testid="footer-confidentialite" className="hover:text-[#f7f5f0] transition-colors">Confidentialité</a>
          </div>
        </div>

        <div className="mt-8 flex justify-end overflow-visible" data-testid="urgence-end-section">
          <UrgenceButton />
        </div>
      </div>
    </footer>
  );
}
